module.exports = {
    theme: {
        extend: {
            screens:{
                'xs': { max:'639px' }
            },
            colors: {
                palette: {
                    black: '#000',
                    green: '#4fe672',
                    darkgreen: '#18cb44',
                    red: '#F95455',
                    orange: '#FC9429',
                    yellow: '#F5D61F',
                    turquoise: '#00B5BA'
                }
            },
            zIndex: {
                '-10': -10,
                '-20': -20,
            },
            opacity: {
                '5': '.05',
                '60': '.6',
                '80': '.8',
            },
            spacing: {
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '33.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                '1/5': '20%',
                '2/5': '40%',
                '3/5': '60%',
                '4/5': '80%',
                '1/6': '16.666667%',
                '2/6': '33.333333%',
                '3/6': '50%',
                '4/6': '66.666667%',
                '5/6': '83.333333%',
                '16/9': '56.25%',
                '40vh': '40vh',
                '60vh': '60vh',
                '75vh': '75vh',
                'full': '100%',
            }
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },
    variants: {},
    plugins: [
        require('@tailwindcss/forms'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/aspect-ratio'),
    ],

    /**
     * TODO Medium: Optimize, how do we select only from admin Concord module? Match /admin/ in dir? How to not match unused Modules?
     **/
    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.vue',
        __dirname + '/galaxy/modules/*/resources/**/*.js',
        __dirname + '/galaxy/modules/*/resources/**/*.scss',
        __dirname + '/galaxy/modules/*/resources/**/*.php',

        __dirname + '/app/Modules/*/resources/**/*.vue',
        __dirname + '/app/Modules/*/resources/**/*.js',
        __dirname + '/app/Modules/*/resources/**/*.scss',
        __dirname + '/app/Modules/*/resources/**/*.php',

        __dirname + '/resources/**/*.vue',
        __dirname + '/resources/**/*.js',
        __dirname + '/resources/**/*.scss',
        __dirname + '/resources/**/*.blade.php',
    ],
};
